const TONI = {
  neutral: 'bg-surface-2 text-muted border-line',
  brand: 'bg-brand-50 text-brand-700 border-brand-500/30',
  success: 'bg-success-bg text-success border-success/30',
  warning: 'bg-warning-bg text-warning border-warning/30',
  danger: 'bg-danger-bg text-danger border-danger/30',
  info: 'bg-info-bg text-info border-info/30',
};

export default function Badge({ tone = 'neutral', icon: Icon, children, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5
      text-2xs font-medium ${TONI[tone]} ${className}`}>
      {Icon && <Icon size={12} aria-hidden />}
      {children}
    </span>
  );
}
